import { render, staticRenderFns } from "./DetailsHabitant.vue?vue&type=template&id=2df72f38&scoped=true"
import script from "./DetailsHabitant.vue?vue&type=script&lang=js"
export * from "./DetailsHabitant.vue?vue&type=script&lang=js"
import style0 from "./DetailsHabitant.vue?vue&type=style&index=0&id=2df72f38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df72f38",
  null
  
)

export default component.exports